import React from 'react'
import PropTypes from 'prop-types'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import MUICheckbox from '@material-ui/core/Checkbox'


const createOnChangeHandler = (onChange, name) => (e, checked) => {
  return onChange({
    ...e,
    target: {
      name,
      value: checked,
    },
  })
}


const Checkbox = ({
  name,
  label,
  onChange,
  rootClassName,
  ...props
}) => (
  <FormControlLabel
    label={label}
    className={rootClassName}
    control={(
      <MUICheckbox
        name={name}
        onChange={createOnChangeHandler(onChange, name)}
        {...props}
      />
    )}
  />
)


Checkbox.defaultProps = {
  onChange: () => {},
}


Checkbox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func,
  className: PropTypes.string,
  rootClassName: PropTypes.string,
}


export default Checkbox
